import { Reducer } from "redux";
import { PlansAction, PlansState } from "./types";

const initialState: PlansState = {
  status: "init"
};

const reducer: Reducer<PlansState, PlansAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case "plans/FETCH_INFO":
      if (state.status === "loaded") {
        return {
          ...state,
          // No update this information
          // status: "updating"
        };
      } else {
        return {
          status: "loading"
        };
      }
    case "plans/FETCH_INFO_SUCCEEDED":
      return {
        status: "loaded",
        payload: action.plans
      };
    case "plans/FETCH_INFO_FAILED":
      return {
        status: "error",
        error: action.error
      };

    default:
      return state;
  }
};

export default reducer;
